// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","672":"component---src-pages-qr-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"d06e0084a5ebeeafa3fd","672":"491eb57c4bb42e341cc5","678":"2f2ebbfa5632343a290e","883":"8bd16cd5150dd18dff63"}[chunkId] + ".js";
};